const en = {
  nav: {
    groups: {
      overview: "Overview",
      business: "Business",
      recruitment: "Recruitment",
      management: "Management",
      platform: "Platform",
      intelligence: "Smart Assistant",
    },
    dashboard: "Dashboard",
    ateliers: "Ateliers",
    subscriptions: "Subscriptions",
    order_plans: "Plan package orders",
    demo_tenants: "Demo tenants",
    expired_demo_tenants: "Expired demo tenants",
    plans: "Plans",
    payments: "Payments",
    payment_gateways: "Payment Gateways",
    users: "Users",
    admin_roles: "Admin Roles",
    settings: "Settings",
    feature_flags: "Feature Flags",
    support: "Support",
    notifications: "Notifications",
    messages: "Messages",
    recruitment_jobs: "Jobs",
    recruitment_applications: "Applications",
    recruitment_settings: "Recruitment settings",
    logs: "Logs",
    integrations: "Integrations",
    marketing: "Marketing",
    intel_command: "Command Center",
    intel_conversations: "Conversations",
    intel_leads: "Leads",
    intel_followups: "Follow-ups",
    sign_out: "Sign Out",
  },
  admin: { role: "Super Admin" },
  page: {
    dashboard: { title: "Dashboard", subtitle: "Welcome back, Super Admin" },
    ateliers: { title: "Ateliers", subtitle: "Manage all registered ateliers" },
    subscriptions: {
      title: "Subscriptions",
      subtitle: "Monitor all active subscriptions",
    },
    order_plans: {
      title: "Plan package orders",
      subtitle: "Review and approve requests to purchase plan packages",
    },
    demo_tenants: {
      title: "Demo tenants",
      subtitle: "Create plan-free demo accounts for 1–7 days",
    },
    expired_demo_tenants: {
      title: "Expired demo tenants",
      subtitle: "Demo accounts whose trial period has ended",
    },
    plans: { title: "Plans", subtitle: "Manage pricing plans & features" },
    payments: { title: "Payments", subtitle: "Track all transactions" },
    payment_gateways: {
      title: "Payment Gateways",
      subtitle: "Manage manual payment methods",
    },
    users: { title: "Admin Users", subtitle: "Manage admin team members" },
    admin_roles: {
      title: "Admin Roles",
      subtitle: "Configure roles & permissions",
    },
    settings: { title: "Settings", subtitle: "System-wide configuration" },
    feature_flags: {
      title: "Feature Flags",
      subtitle: "Toggle features per plan",
    },
    support: { title: "Support", subtitle: "Manage support tickets" },
    notifications: {
      title: "Notifications",
      subtitle: "Send broadcast messages",
    },
    recruitment_jobs: { title: "Jobs", subtitle: "Create, publish and archive open roles" },
    recruitment_applications: { title: "Applications", subtitle: "Review candidates and the hiring pipeline" },
    recruitment_settings: { title: "Recruitment settings", subtitle: "Applications intake and team alerts" },
    profile: {
      title: "My Profile",
      subtitle: "Manage account details and password",
    },
    logs: { title: "Logs", subtitle: "System activity logs" },
    integrations: { title: "Integrations", subtitle: "Third-party services" },
    marketing: {
      title: "Marketing",
      subtitle: "Coupons, referrals & campaigns",
    },
    intelligence: {
      title: "Smart Assistant",
      subtitle: "Command center for conversations, leads, and follow-ups",
    },
    demo_tenant_performance: {
      title: "Trial account performance",
      subtitle: "Journey, engagement, and purchase signals",
    },
  },
  topbar: {
    search_placeholder: "Search anything...",
    my_profile: "My Profile",
    sign_out: "Sign Out",
  },
  stats: {
    total_revenue: "Total Revenue",
    active_subscriptions: "Active Subscriptions",
    new_ateliers: "New Ateliers",
    churn_rate: "Churn Rate",
    vs_last_month: "vs last month",
  },
  chart: {
    revenue: {
      title: "Revenue Growth",
      subtitle: "Monthly revenue trend",
      monthly: "Monthly",
      yearly: "Yearly",
    },
    growth: {
      title: "Atelier Growth",
      subtitle: "New vs churned ateliers",
      new_ateliers: "New Ateliers",
      churned: "Churned",
    },
  },
  recent: {
    subscriptions: {
      title: "Latest Subscriptions",
      subtitle: "Most recent signups",
      view_all: "View all",
    },
    activities: {
      title: "Recent Activity",
      subtitle: "System-wide activity log",
      view_logs: "View logs",
    },
  },
  table: {
    showing: "Showing",
    of: "of",
    no_ateliers: "No ateliers found",
    no_subscriptions: "No subscriptions found",
    no_order_plans: "No plan package orders yet",
    ateliers_count: "ateliers",
    subscriptions_count: "subscriptions",
    order_plans_count: "orders",
  },
  /** Tenant/subscription plan tier labels (API slugs + common aliases) */
  plan_tiers: {
    basic: "Basic",
    professional: "Professional",
    enterprise: "Enterprise",
    starter: "Starter",
    pro: "Pro",
  },
  ateliers: {
    filter: {
      all: "All",
      active: "Active",
      suspended: "Suspended",
      pending: "Pending",
      trial: "Trial",
    },
    search_placeholder: "Search ateliers...",
    add_atelier: "Add Atelier",
    loading: "Loading ateliers…",
    prefer_order_plans_banner: "Preferred path for new customers: review plan requests first.",
    go_order_plans: "Open plan requests",
    col: {
      atelier: "Atelier",
      phone: "Phone",
      domain: "Domain",
      storefront: "Storefront",
      workspace: "Workspace",
      open_login: "Enter tenant",
      created_by: "Created by",
      plan: "Plan",
      status: "Status",
      employees: "Employees",
      created: "Created",
      actions: "Actions",
    },
    login_as_loading: "Signing in…",
    modal: {
      title: "Atelier Details",
      edit: "Edit Atelier",
      login_as: "Login as atelier",
      tenant_id: "Tenant ID",
      workspace: "Workspace ID",
      login_url: "Tenant login link",
      login_url_hint: "Use Login as atelier to open the tenant dashboard as the owner.",
      created_by: "Created by admin",
      employees: "Employees",
      branches: "Branches",
      phone: "Phone",
      created: "Created",
      updated: "Last updated",
      renewal: "Renewal",
      plan: "Plan",
      change_plan: "Change plan",
      save_plan: "Save plan",
      trial_ends: "Trial ends",
      db_name: "Tenant database",
      monthly_revenue: "Monthly Revenue",
      free_trial: "Free Trial",
      add_domain: "Add domain",
      domain_placeholder: "e.g. ahmad-alias",
      domain_submit: "Add",
      domain_required: "Enter a domain slug.",
      domain_delete: "Remove domain",
      migrate: "Migrate DB",
      seed: "Seed",
      delete_tenant: "Delete atelier",
      delete_confirm_title: "Delete this atelier?",
      delete_tenant_confirm:
        'You are about to permanently delete "{{name}}". All tenant data will be removed. This action cannot be undone.',
      delete_confirm_action: "Delete permanently",
    },
    custom_plan: {
      option: "Custom Plan",
      title: "Tenant-specific custom plan",
      hint: "This plan belongs to this atelier only and will not appear in the public plan catalog.",
      monthly_price: "Monthly price",
      yearly_price: "Yearly price",
      interval: "Billing interval",
      monthly: "Monthly",
      yearly: "Yearly",
      currency: "Currency",
      starts_at: "Subscription start date",
      duration: "Subscription duration",
      duration_monthly: "One month from the start date",
      duration_yearly: "One year from the start date",
      ends_at: "End date",
      features: "Features and usage limits",
      required: "Enter monthly price, yearly price, and start date for the custom plan.",
    },
    create: {
      title: "Add atelier (tenant)",
      cancel: "Cancel",
      submit: "Create",
      submitting: "Creating…",
      provisioning_missing_tenant_id:
        "Atelier was created, but automatic provisioning failed (missing tenant id).",
      fields: {
        name: "Company / atelier name",
        plan: "Plan",
        email: "Admin email",
        password: "Admin password",
        phone: "Phone (optional)",
      },
      plan_required: "Please select a plan for the tenant.",
      loading_plans: "Loading plans…",
      prefer_order_plans: "Preferred path for new customers is reviewing an incoming plan request.",
      go_order_plans: "Go to plan requests",
    },
    edit: {
      title: "Edit atelier",
      name: "Name",
      plan: "Plan",
      submit: "Save",
      submitting: "Saving…",
    },
  },
  subscriptions: {
    loading: "Loading subscriptions…",
    summary: {
      total: "Total Subscriptions",
      active: "Active",
      pending: "Pending",
      expired: "Expired",
      mrr: "Monthly Recurring Revenue",
      page_scope: "this page",
    },
    search_on_page: "{{count}} matches on this page",
    filter: {
      all: "All",
      active: "Active",
      pending: "Pending",
      rejected: "Rejected",
      cancelled: "Cancelled",
      trial: "Trial",
      expired: "Expired",
    },
    search_placeholder: "Search subscriptions...",
    col: {
      id: "ID",
      atelier: "Atelier",
      tenant: "Tenant",
      plan: "Plan",
      price: "Price",
      status: "Status",
      renewal_date: "Renewal Date",
      ends_at: "Ends at",
      starts_at: "Starts at",
      last_payment: "Last Payment",
      actions: "Actions",
    },
    detail: {
      title: "Subscription details",
      status: "Status",
      payments: "Payments",
      no_payments: "No payments recorded.",
      payments_table: {
        id: "ID",
        plan: "Plan",
        price: "Amount",
        paid_at: "Paid at",
        period: "Coverage period",
        status: "Status",
      },
      save_status: "Apply status",
      saving: "Saving…",
    },
    expired: "Expired",
    free_trial: "Free Trial",
    monthly: "monthly",
    yearly: "yearly",
  },
  demo_tenants: {
    add: "Create demo account",
    loading: "Loading demo tenants…",
    empty: "No demo tenants yet",
    banner:
      "Demo accounts have no plan and auto-expire after the selected period, with a user notification.",
    search_placeholder: "Search by name or email…",
    open_login: "Enter tenant",
    view_performance: "View performance",
    days_left: "{{count}} day(s) left",
    days_label: "{{days}} days",
    filter: {
      all: "All",
      active: "Active",
      expired: "Expired",
      suspended: "Suspended",
    },
    summary: {
      total: "Total demos",
      active: "Active",
      expired: "Expired",
      suspended: "Suspended",
    },
    col: {
      name: "Account",
      email: "Email",
      created_by: "Created by admin",
      days: "Duration",
      remaining: "Remaining",
      ends_at: "Ends at",
      status: "Status",
      created: "Created at",
      actions: "Actions",
    },
    create: {
      title: "Create demo tenant",
      hint: "Not linked to a plan. Choose 1–7 days; access ends automatically afterwards.",
      cancel: "Cancel",
      submit: "Create account",
      submitting: "Creating…",
      days_help: "Selected duration: {{days}} day(s)",
      fields: {
        name: "Atelier / company name",
        email: "Admin email",
        password: "Admin password",
        phone: "Phone (optional)",
        days: "Trial duration (days)",
      },
    },
    performance: {
      back: "Back to demo tenants",
      title: "Trial account performance",
      started: "Started",
      last_active: "Last active",
      duration: "Trial duration",
      duration_days: "{{count}} day(s)",
      onboarding: "Onboarding",
      health: "Trial Health",
      summary: "Performance summary",
      journey: "Onboarding journey",
      activity: "Activity",
      last_action: "Last action",
      engagement: "Engagement",
      activation: "Activation",
      signals: "Purchase Signals",
      recommendation: "Recommendation",
      pricing: "Pricing / Upgrade",
      lifecycle: "Trial lifecycle",
      priority: "Sales Priority",
      why: "Why this score?",
      metrics: "Business metrics",
      load_more: "Load more",
      empty_activity: "No activity yet",
      none: "Not done yet",
      filters: {
        type: "Activity type",
        period: "Period",
        all: "All",
        onboarding: "Onboarding",
        customers: "Customers",
        reservations: "Reservations",
        inventory: "Inventory",
        purchases: "Purchases",
        accounts: "Accounts",
        system: "System",
        today: "Today",
        last_3_days: "Last 3 days",
        last_7_days: "Last 7 days",
        all_activity: "All activity",
      },
      status: {
        active: "Active",
        expired: "Expired",
        converted: "Converted",
        suspended: "Suspended",
      },
      health_band: {
        highly_engaged: "Highly Engaged",
        engaged: "Engaged",
        exploring: "Exploring",
        idle: "Idle",
      },
      engagement_level: {
        hot: "Hot",
        warm: "Warm",
        cold: "Cold",
        inactive: "Inactive",
      },
      activation_status: {
        not_activated: "Not Activated",
        partially_activated: "Partially Activated",
        activated: "Activated",
        fully_activated: "Fully Activated",
      },
      priority_level: {
        high: "HIGH",
        medium: "MEDIUM",
        low: "LOW",
      },
      pricing_keys: {
        pricing_viewed: "Pricing Viewed",
        upgrade_clicked: "Upgrade Clicked",
        checkout_started: "Checkout Started",
        payment: "Payment",
      },
      metrics_keys: {
        customers: "Customers",
        reservations: "Reservations",
        products: "Products",
        purchase_orders: "Purchase orders",
        received_orders: "Received orders",
        inventory_items: "Inventory items",
        financial_activities: "Financial operations",
        onboarding: "Onboarding",
      },
      lifecycle_stage: {
        created: "Created",
        started: "Started",
        activated: "Activated",
        engaged: "Engaged",
        upgrade_intent: "Upgrade Intent",
        converted: "Converted",
        expired: "Expired",
      },
    },
  },
  expired_demo_tenants: {
    loading: "Loading expired demo tenants…",
    empty: "No expired demo tenants",
    banner: "Demo accounts whose trial has ended are moved here automatically.",
    summary: {
      total: "Total expired",
      expired: "Expired",
      suspended: "Suspended",
    },
  },
  order_plans: {
    loading: "Loading plan package orders…",
    summary: {
      total: "Total package orders",
      awaiting: "Awaiting review",
      approved: "Approved",
      rejected: "Rejected",
      page_scope: "this page",
    },
    search_on_page: "{{count}} matches on this page",
    search_placeholder: "Search by name, email, workspace…",
    filter: {
      all: "All",
      awaiting_review: "Awaiting review",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    col: {
      id: "ID",
      name: "Customer",
      phone: "Phone",
      plan: "Plan",
      price: "Price",
      tenant_id: "Workspace",
      subscription_id: "Subscription",
      status: "Status",
      created_at: "Created",
      updated_at: "Updated",
      actions: "Actions",
    },
    detail: {
      title: "Plan package order details",
      customer: "Customer",
      plan_section: "Requested plan",
      payment_section: "Payment proof",
      payment_reference: "Payment reference",
      payment_submitted_at: "Submitted at",
      payment_proof: "View transfer receipt",
      payment_hint: "Confirm the transfer was received before approving and activating the account.",
      status: "Decision",
      save_status: "Apply status",
      saving: "Saving…",
      approve: "Approve & activate",
      reject: "Reject request",
      confirm_approve:
        "Approve and activate this account? Login credentials will be emailed to the customer.",
      confirm_reject: "Reject this plan request?",
      review_first: "Open details to review payment proof, then approve or reject here.",
      next_steps: "Next steps",
      open_atelier: "Open atelier",
      open_subscription: "Open subscription",
      open_payments: "Open payments",
    },
  },
  plans: {
    add_plan: "Add Plan",
    edit_plan: "Edit Plan",
    delete_plan: "Delete Plan",
    loading: "Loading plans…",
    most_popular: "Most Popular",
    active_subscribers: "Active Subscribers",
    monthly: "Monthly",
    yearly: "Yearly",
    max_employees: "Max Employees",
    max_branches: "Max Branches",
    max_invoices: "Max Invoices",
    max_invoices_sale: "Sale invoices",
    max_invoices_rent: "Rent invoices",
    max_invoices_tailoring: "Tailoring invoices",
    max_assistant_messages: "Smart assistant messages",
    features: "Features",
    unlimited: "Unlimited",
    limits: "Limits",
    currency: "Currency",
    plan_active: "Active",
    plan_inactive: "Inactive",
    duration_days: "days",
    price_once: "one-time",
    description_heading: "Description",
    confirm_delete:
      "Are you sure you want to delete this plan? This action cannot be undone.",
    no_plans: "No plans found",
    prev_page: "Previous",
    next_page: "Next",
    summary: {
      total: "Total Plans",
      active: "Active Plans",
      inactive: "Inactive Plans",
      subscribers: "Total Subscribers",
    },
    form: {
      title_add: "Add New Plan",
      title_edit: "Edit Plan",
      title_label: "Title",
      title_placeholder: "e.g. basic",
      description: "Description",
      description_placeholder: "Plan details…",
      days: "Subscription duration (days)",
      days_placeholder: "365",
      days_help: "Number of days each atelier subscription lasts when this plan is activated or renewed.",
      price: "Base Price",
      price_placeholder: "100",
      base_price_legacy: "Legacy",
      base_price_help: "Base price - used as fallback if no monthly/yearly price is set",
      name: "Plan Name",
      name_placeholder: "e.g. Pro",
      monthly_price: "Monthly Price",
      yearly_price: "Yearly Price",
      yearly_discount: "Yearly Discount (%)",
      currency: "Currency",
      employees_label: "Max Employees",
      branches_label: "Max Branches",
      invoices_label: "Max Invoices",
      limits_title: "Plan Limits",
      billing_cycle: "Billing Cycle",
      features_label: "Features & Limits",
      features_placeholder: "Type a feature and press Enter",
      active_label: "Plan Active",
      save: "Save Plan",
      saving: "Saving…",
      cancel: "Cancel",
    },
  },
  payments: {
    view_invoice: "View Invoice",
    refund: "Refund",
    mark_paid: "Mark as Paid",
    confirm_refund:
      "Are you sure you want to refund this payment? This action cannot be undone.",
    confirm_mark_paid: "Mark this payment as paid?",
    filter: {
      all: "All",
      paid: "Paid",
      pending: "Pending",
      refunded: "Refunded",
      failed: "Failed",
    },
    search_placeholder: "Search invoices...",
    col: {
      invoice: "Invoice",
      atelier: "Atelier",
      amount: "Amount",
      method: "Method",
      status: "Status",
      date: "Date",
      actions: "Actions",
    },
    no_payments: "No payments found",
    payments_count: "payments",
    method: {
      visa: "Visa",
      mada: "Mada",
      stc: "STC Pay",
      bank: "Bank Transfer",
      cash: "Cash",
    },
    summary: {
      total_revenue: "Total Revenue",
      paid: "Paid Invoices",
      pending: "Pending",
      refunded: "Refunded",
    },
    invoice_modal: {
      title: "Invoice Details",
      invoice_to: "Invoice To",
      issued_date: "Issued",
      due_date: "Due Date",
      plan: "Plan",
      billing_cycle: "Billing",
      subtotal: "Subtotal",
      tax: "VAT (15%)",
      total: "Total",
      print: "Print",
      close: "Close",
    },
  },
  settings: {
    tabs: {
      general: "General",
      landing: "Homepage",
      email: "Email",
      payment: "Payment",
      sms: "SMS",
    },
    save: "Save Changes",
    saved: "Settings saved successfully!",
    test: "Send Test",
    unsaved: "You have unsaved changes",
    general: {
      title: "General Settings",
      subtitle: "Core platform configuration",
      platform_name: "Platform Name",
      platform_name_desc: "Shown in emails and notifications",
      support_email: "Support Email",
      support_email_desc: "Main contact email for users",
      currency: "Default Currency",
      timezone: "Time Zone",
      trial_days: "Free Trial Duration (days)",
      trial_days_desc: "Number of days for free trials",
      logo_url: "Logo URL",
      logo_url_desc: "URL to your platform logo",
      maintenance_mode: "Maintenance Mode",
      maintenance_desc: "Disable access for all ateliers temporarily",
      password_section_title: "Change password",
      password_section_subtitle: "Update your admin account password",
      current_password: "Current password",
      new_password: "New password",
      confirm_password: "Confirm new password",
      update_password: "Update password",
      password_updating: "Updating…",
      password_success: "Password updated successfully.",
      password_mismatch: "New password and confirmation do not match.",
      password_fill_all: "Please fill in all password fields.",
    },
    email: {
      title: "Email Settings",
      subtitle: "SMTP & notification configuration",
      smtp_host: "SMTP Host",
      smtp_port: "SMTP Port",
      smtp_user: "SMTP Username",
      smtp_pass: "SMTP Password",
      from_name: "From Name",
      from_email: "From Email",
      enable_notifications: "Enable Email Notifications",
      enable_desc: "Send automated emails for registrations, renewals, etc.",
    },
    payment: {
      title: "Payment Settings",
      subtitle: "Gateway & billing configuration",
      gateway: "Payment Gateway",
      api_key: "API Key",
      api_key_desc: "Your payment gateway secret key",
      webhook_secret: "Webhook Secret",
      webhook_desc: "Used to verify payment callbacks",
      vat_rate: "VAT Rate (%)",
      vat_desc: "Applied to all invoices",
      sandbox_mode: "Sandbox / Test Mode",
      sandbox_desc: "Use test credentials instead of live",
    },
    sms: {
      title: "SMS Settings",
      subtitle: "SMS provider configuration",
      provider: "SMS Provider",
      api_key: "API Key",
      sender_id: "Sender ID",
      sender_id_desc: "The name or number shown as sender",
      enable_sms: "Enable SMS Notifications",
      enable_desc: "Send SMS for OTP, reminders and renewal alerts",
    },
    landing: {
      contact_title: "Contact & footer",
      contact_subtitle: "Shown on the public homepage",
      social_title: "Social media links",
      social_subtitle: "Leave a field empty to hide that icon",
      modules_title: "System modules",
      modules_subtitle: "Cards shown in the homepage modules section",
      company_name: "Platform name",
      phone: "Phone",
      phone_desc: "Phone number shown in the contact section",
      whatsapp: "WhatsApp",
      whatsapp_desc: "WhatsApp number with country code, e.g. 00201070205189",
      email: "Email",
      address: "Address",
      working_hours: "Working hours",
      footer_copyright: "Footer text",
      footer_copyright_desc: "Copyright line at the bottom of the page",
      facebook_url: "Facebook",
      instagram_url: "Instagram",
      twitter_url: "X / Twitter",
      linkedin_url: "LinkedIn",
      tiktok_url: "TikTok",
      youtube_url: "YouTube",
      add_module: "Add module",
      module_label: "Module name",
      no_modules: "No modules yet. Add one to show it on the homepage.",
      loading: "Loading homepage settings…",
      saving: "Saving…",
      load_error: "Could not load homepage settings",
      save_error: "Could not save homepage settings",
    },
  },
  support: {
    new_ticket: "New Ticket",
    reply: "Reply",
    close_ticket: "Close Ticket",
    confirm_close:
      "Are you sure you want to close this ticket? No further replies will be allowed.",
    no_tickets: "No tickets found",
    tickets_count: "tickets",
    filter: {
      all: "All",
      open: "Open",
      pending: "Pending",
      resolved: "Resolved",
      closed: "Closed",
    },
    search_placeholder: "Search tickets...",
    priority: {
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical",
    },
    col: {
      id: "Ticket",
      atelier: "Atelier",
      subject: "Subject",
      priority: "Priority",
      status: "Status",
      created: "Created",
      actions: "Actions",
    },
    summary: {
      total: "Total Tickets",
      open: "Open",
      resolved: "Resolved",
      closed: "Closed",
    },
    reply_modal: {
      title: "Ticket Details",
      conversation: "Conversation",
      your_reply: "Your Reply",
      reply_placeholder: "Type your reply...",
      send_reply: "Send Reply",
      close_ticket: "Close Ticket",
      admin: "Admin",
    },
  },
  actions: {
    view: "View",
    edit: "Edit",
    suspend: "Suspend",
    activate: "Activate",
    login_as: "Login As",
    delete: "Delete",
    view_details: "View Details",
    change_plan: "Change Plan",
    cancel: "Cancel",
    renew: "Renew",
    confirm: "Confirm",
    close: "Close",
  },
  status: {
    active: "Active",
    suspended: "Suspended",
    pending: "Pending",
    trial: "Trial",
    cancelled: "Cancelled",
    expired: "Expired",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    paid: "Paid",
    refunded: "Refunded",
    failed: "Failed",
    payment_submitted: "Awaiting review",
  },
  coming_soon: {
    title: "Coming Soon",
    badge: "This page is under development",
    plans: "Manage your pricing plans and features",
    payments: "Track and manage all payment transactions",
    users: "Manage admin team members and their access",
    admin_roles: "Configure roles and permissions for the admin team",
    settings: "Configure system-wide settings",
    feature_flags: "Toggle features on or off per plan",
    support: "Manage and respond to support tickets",
    notifications: "Send broadcast notifications to ateliers",
    logs: "View system activity and audit logs",
    integrations: "Connect third-party services and APIs",
    marketing: "Manage coupons, referrals and free trials",
  },
  users: {
    add_user: "Add Admin",
    no_users: "No team members found",
    users_count: "members",
    confirm_delete:
      "Are you sure you want to remove this admin? They will lose all access immediately.",
    confirm_suspend: "Suspend this admin? They will lose access immediately.",
    confirm_activate: "Reactivate this admin account?",
    filter: { all: "All", active: "Active", suspended: "Suspended" },
    search_placeholder: "Search team members...",
    col: {
      member: "Member",
      role: "Role",
      status: "Status",
      last_login: "Last Login",
      created: "Joined",
      actions: "Actions",
    },
    summary: {
      total: "Total Admins",
      active: "Active",
      suspended: "Suspended",
      roles: "Roles Used",
    },
    roles: {
      super_admin: "Super Admin",
      admin: "Admin",
      support: "Support Agent",
      finance: "Finance",
      content: "Content Manager",
    },
    role_desc: {
      super_admin: "Full access to all platform features",
      admin: "Manage ateliers, subscriptions & payments",
      support: "View & respond to support tickets only",
      finance: "Access to payments, invoices & reports",
      content: "Manage plans, features & notifications",
    },
    form: {
      title_add: "Add New Admin",
      title_edit: "Edit Admin",
      name: "Full Name",
      name_placeholder: "e.g. Ahmed Al-Rashidi",
      email: "Email Address",
      email_placeholder: "admin@dressnmore.sa",
      role: "Role",
      password: "Password",
      password_edit: "New Password",
      password_hint: "Leave blank to keep current password",
      active: "Account Active",
      save: "Save Admin",
      cancel: "Cancel",
    },
  },
  feature_flags: {
    save_all: "Save Changes",
    saved: "Changes saved!",
    unsaved: "unsaved changes",
    search_placeholder: "Search features...",
    col: {
      feature: "Feature",
      category: "Category",
      starter: "Starter",
      pro: "Pro",
      enterprise: "Enterprise",
    },
    categories: {
      core: "Core Features",
      advanced: "Advanced Features",
      integrations: "Integrations",
      beta: "Beta Features",
    },
    no_flags: "No features found",
    flags_count: "features",
    beta_badge: "BETA",
    summary: {
      total: "Total Features",
      enabled_all: "Fully Enabled",
      partial: "Partially Enabled",
      beta_count: "Beta Features",
    },
  },
  admin_roles: {
    add_role: "Add Role",
    no_roles: "No roles defined",
    confirm_delete:
      "Delete this role? Users assigned to it will lose their permissions.",
    system_role: "System Role",
    system_role_desc: "Cannot be modified or deleted",
    users_using: "users",
    permissions_count: "permissions",
    all_permissions: "Full Access",
    select_all: "All",
    deselect_all: "None",
    groups: {
      dashboard: "Dashboard",
      ateliers: "Ateliers",
      subscriptions: "Subscriptions",
      order_plans: "Order Plans",
      demo_tenants: "Demo Tenants",
      payments: "Payments",
      payment_gateways: "Payment Gateways",
      plans: "Plans",
      flags: "Feature Flags",
      support: "Support",
      users: "Users",
      admin_roles: "Admin Roles",
      reports: "Reports",
      settings: "Settings",
      notifs: "Notifications",
      recruitment: "Recruitment",
      logs: "Logs",
      marketing: "Marketing",
      integrations: "Integrations",
      ai_sales: "AI Sales Agent",
    },
    perms: {
      view_dashboard: "View Dashboard",
      view_ateliers: "View Ateliers",
      add_atelier: "Add Atelier",
      edit_atelier: "Edit Atelier",
      suspend_atelier: "Suspend Atelier",
      delete_atelier: "Delete Atelier",
      login_as_atelier: "Login As Atelier",
      view_subscriptions: "View Subscriptions",
      edit_subscription: "Edit Subscription",
      cancel_subscription: "Cancel Subscription",
      renew_subscription: "Renew Subscription",
      view_order_plans: "View Order Plans",
      approve_order_plan: "Approve Order Plan",
      reject_order_plan: "Reject Order Plan",
      delete_order_plan: "Delete Order Plan",
      view_demo_tenants: "View Demo Tenants",
      add_demo_tenant: "Add Demo Tenant",
      view_payments: "View Payments",
      refund_payment: "Refund Payment",
      mark_paid: "Mark as Paid",
      view_payment_gateways: "View Payment Gateways",
      add_payment_gateway: "Add Payment Gateway",
      edit_payment_gateway: "Edit Payment Gateway",
      delete_payment_gateway: "Delete Payment Gateway",
      view_plans: "View Plans",
      add_plan: "Add Plan",
      edit_plan: "Edit Plan",
      delete_plan: "Delete Plan",
      view_flags: "View Feature Flags",
      edit_flags: "Edit Feature Flags",
      view_tickets: "View Tickets",
      reply_ticket: "Reply to Ticket",
      close_ticket: "Close Ticket",
      view_users: "View Users",
      add_user: "Add User",
      edit_user: "Edit User",
      delete_user: "Delete User",
      view_admin_roles: "View Admin Roles",
      add_admin_role: "Add Admin Role",
      edit_admin_role: "Edit Admin Role",
      delete_admin_role: "Delete Admin Role",
      view_reports: "View Reports",
      export_reports: "Export Reports",
      view_settings: "View Settings",
      edit_settings: "Edit Settings",
      view_notifications: "View Notifications",
      send_notifications: "Send Notifications",
      view_recruitment: "View Recruitment",
      manage_recruitment_jobs: "Manage Jobs",
      manage_recruitment_applications: "Manage Applications",
      manage_recruitment_settings: "Manage Recruitment Settings",
      view_logs: "View Logs",
      view_marketing: "View Marketing",
      edit_marketing: "Edit Marketing",
      view_integrations: "View Integrations",
      "ai_sales.view": "View AI Sales Agent",
      "ai_sales.inbox": "AI Sales Inbox",
      "ai_sales.leads": "AI Sales Leads",
      "ai_sales.followups": "AI Sales Follow-ups",
      "ai_sales.knowledge": "AI Sales Knowledge",
      "ai_sales.agent": "AI Sales Agent Settings",
      "ai_sales.analytics": "AI Sales Analytics",
      "ai_sales.manage": "Manage AI Sales Agent",
    },
    form: {
      title_add: "Create New Role",
      title_edit: "Edit Role",
      name: "Role Name",
      name_placeholder: "e.g. Billing Manager",
      description: "Description",
      description_placeholder: "What can this role do?",
      color: "Role Color",
      permissions_title: "Permissions",
      save: "Save Role",
      cancel: "Cancel",
    },
  },
  notifications: {
    send: "Send Notification",
    sending: "Sending...",
    sent_success: "Notification sent successfully!",
    compose: {
      title: "Compose Notification",
      subtitle: "Send broadcast to your ateliers",
    },
    history_title: "Notification History",
    target: {
      label: "Target Audience",
      all: "All Ateliers",
      by_plan: "By Plan",
      by_status: "By Status",
    },
    channels: {
      label: "Channels",
      inapp: "In-App",
      email: "Email",
      sms: "SMS",
    },
    fields: {
      title: "Title",
      title_placeholder: "Notification title...",
      message: "Message",
      message_placeholder: "Type your message here...",
    },
    col: {
      title: "Title",
      target: "Audience",
      channels: "Channels",
      sent: "Sent",
      opened: "Opened",
      date: "Date",
      status: "Status",
    },
    filter: {
      all: "All",
      sent: "Sent",
      scheduled: "Scheduled",
      draft: "Draft",
      failed: "Failed",
    },
    no_notifications: "No notifications sent yet",
    notifs_count: "notifications",
    status: {
      sent: "Sent",
      scheduled: "Scheduled",
      draft: "Draft",
      failed: "Failed",
      partial: "Partial",
    },
    summary: {
      total_sent: "Total Sent",
      avg_open: "Avg. Open Rate",
      last_7: "Last 7 Days",
      today: "Today",
      delivered: "Delivered to Ateliers",
    },
    preview: "Preview",
    chars_remaining: "chars remaining",
  },
  marketing: {
    tabs: { coupons: "Coupons", referrals: "Referrals", trials: "Free Trials" },
    coupons: {
      add_coupon: "Add Coupon",
      no_coupons: "No coupons found",
      coupons_count: "coupons",
      copy_code: "Copy",
      copied: "Copied!",
      confirm_delete:
        "Delete this coupon? All associated uses will be removed.",
      confirm_toggle: "Toggle this coupon status?",
      types: { percentage: "Percentage", fixed: "Fixed" },
      plan: {
        all: "All Plans",
        starter: "Starter",
        pro: "Pro",
        enterprise: "Enterprise",
      },
      filter: {
        all: "All",
        active: "Active",
        inactive: "Inactive",
        expired: "Expired",
      },
      search_placeholder: "Search coupons...",
      col: {
        code: "Code",
        type: "Type",
        value: "Value",
        usage: "Usage",
        plan: "Plan",
        status: "Status",
        expires: "Expires",
        actions: "Actions",
      },
      summary: {
        total: "Total Coupons",
        active: "Active",
        uses: "Total Uses",
        savings: "Discounts Given",
      },
      form: {
        title_add: "Add New Coupon",
        title_edit: "Edit Coupon",
        code: "Coupon Code",
        code_placeholder: "e.g. SUMMER25",
        generate: "Generate",
        type: "Discount Type",
        value: "Discount Value",
        value_placeholder: "e.g. 25",
        max_uses: "Max Uses",
        max_uses_hint: "0 = Unlimited",
        target_plan: "Target Plan",
        expiry: "Expiry Date",
        active: "Coupon Active",
        save: "Save Coupon",
        cancel: "Cancel",
      },
    },
    referrals: {
      no_referrals: "No referrals found",
      referrals_count: "referrers",
      commission_settings: "Commission Settings",
      commission_rate_label: "Commission per conversion",
      commission_placeholder: "% or fixed amount",
      search_placeholder: "Search referrers...",
      filter: { all: "All", active: "Active", paused: "Paused" },
      col: {
        referrer: "Referrer",
        code: "Ref. Code",
        referred: "Referred",
        converted: "Converted",
        earned: "Commission",
        joined: "Joined",
        status: "Status",
        actions: "Actions",
      },
      summary: {
        total: "Total Referred",
        active: "Active Referrers",
        converted: "Converted",
        commission: "Total Commission",
      },
      confirm_pause: "Pause this referrer? They won't earn new commissions.",
      confirm_activate: "Reactivate this referrer?",
    },
    trials: {
      grant_trial: "Grant Trial",
      no_trials: "No free trials found",
      trials_count: "trials",
      days_remaining: "days left",
      expired_label: "Expired",
      filter: {
        all: "All",
        active: "Active",
        expired: "Expired",
        converted: "Converted",
        cancelled: "Cancelled",
      },
      search_placeholder: "Search trials...",
      col: {
        atelier: "Atelier",
        plan: "Plan",
        start: "Started",
        end: "Ends",
        days: "Remaining",
        status: "Status",
        actions: "Actions",
      },
      summary: {
        active: "Active Trials",
        expired: "Expired",
        converted: "Converted",
        rate: "Conversion Rate",
      },
      extend: "Extend",
      convert: "Convert to Paid",
      cancel_trial: "Cancel Trial",
      confirm_convert: "Convert this atelier's trial to a paid subscription?",
      confirm_cancel: "Cancel this free trial? The atelier will lose access.",
      extend_modal: {
        title: "Extend Free Trial",
        days_label: "Additional Days",
        save: "Extend Trial",
        cancel: "Cancel",
      },
    },
  },
  logs: {
    export: "Export CSV",
    no_logs: "No log entries found",
    logs_count: "entries",
    search_placeholder: "Search actions...",
    time: { all: "All Time", today: "Today", week: "7 Days", month: "30 Days" },
    filter: { all_types: "All Types", all_users: "All Users" },
    types: {
      auth: "Auth",
      atelier: "Atelier",
      payment: "Payment",
      settings: "Settings",
      system: "System",
      error: "Error",
      support: "Support",
    },
    severity: {
      info: "Info",
      warning: "Warning",
      error: "Error",
      success: "Success",
    },
    col: {
      time: "Timestamp",
      type: "Type",
      severity: "Sev.",
      action: "Action",
      user: "Admin",
      ip: "IP Address",
    },
    summary: {
      total: "Total Events",
      errors: "Errors",
      warnings: "Warnings",
      today: "Today",
    },
  },
  profile: {
    info_title: "Basic Information",
    info_subtitle: "Update your name, email, and phone",
    password_title: "Change Password",
    password_subtitle: "Use a strong password with at least 8 characters",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    save: "Save Changes",
    change_password: "Update Password",
    name: "Full name",
    email: "Email address",
    phone: "Phone number",
    phone_hint: "Optional — for quick contact",
    last_login: "Last login",
    joined: "Joined",
    status_active: "Active",
    status_suspended: "Suspended",
    change_avatar: "Change photo",
    remove_avatar: "Remove photo",
    saved: "Profile saved successfully",
    save_failed: "Could not save profile",
    validation_required: "Name and email are required",
    password_required: "Fill all password fields",
    password_min: "Password must be at least 8 characters",
    password_mismatch: "Password confirmation does not match",
    password_changed: "Password changed successfully",
    password_failed: "Could not change password",
    avatar_saved: "Profile photo updated",
    avatar_removed: "Profile photo removed",
    avatar_failed: "Could not update photo",
    avatar_invalid: "File must be an image",
    avatar_too_large: "Image must be 5MB or smaller",
  },
  login: {
    title: "Welcome Back",
    subtitle: "Sign in to your super admin dashboard",
    email: "Email Address",
    email_placeholder: "admin@dressnmore.sa",
    password: "Password",
    password_placeholder: "Enter your password",
    submit: "Sign In",
    submitting: "Signing in...",
    error: "Invalid email or password. Please try again.",
    brand_title: "Admin Control Center",
    brand_desc:
      "Manage your entire Dressnmore SaaS platform from one powerful dashboard.",
    features: {
      f1: "Complete Platform Overview",
      f2: "Real-time Analytics & Reports",
      f3: "Multi-atelier Management",
    },
  },
  payment_gateways: {
    add_gateway: "Add Gateway",
    no_gateways: "No payment gateways found",
    gateways_count: "gateways",
    confirm_delete: "Delete this gateway? This action cannot be undone.",
    confirm_toggle_on: "Activate this payment gateway?",
    confirm_toggle_off:
      "Deactivate this payment gateway? Ateliers won't see it.",
    copy_number: "Copy",
    copied: "Copied!",
    filter: { all: "All", active: "Active", inactive: "Inactive" },
    search_placeholder: "Search gateways...",
    types: {
      bank: "Bank Transfer",
      vodafone_cash: "Vodafone Cash",
      instapay: "InstaPay",
      orange_cash: "Orange Cash",
      etisalat_cash: "Etisalat Cash",
      fawry: "Fawry",
      other: "Other",
    },
    labels: {
      account_holder: "Account Holder",
      account_number: "Account / Phone Number",
      bank_name: "Bank Name",
      iban: "IBAN",
      instructions: "Payment Instructions",
      usage: "Times Used",
      display_order: "Display Order",
    },
    summary: {
      total: "Total Gateways",
      active: "Active",
      inactive: "Inactive",
      types_count: "Gateway Types",
    },
    form: {
      title_add: "Add Payment Gateway",
      title_edit: "Edit Payment Gateway",
      name: "Gateway Name",
      name_placeholder: "e.g. Al-Ahli Bank",
      type: "Gateway Type",
      account_holder: "Account Holder Name",
      account_holder_placeholder: "e.g. Dressnmore Tech Co.",
      account_number: "Account / Phone Number",
      account_number_placeholder: "e.g. 01012345678",
      bank_name: "Bank Name",
      bank_name_placeholder: "e.g. Saudi National Bank",
      iban: "IBAN (optional)",
      iban_placeholder: "SA12 1000 0000 ...",
      instructions: "Payment Instructions",
      instructions_placeholder:
        "Describe how customers should pay and send proof...",
      display_order: "Display Order",
      active: "Gateway Active",
      save: "Save Gateway",
      cancel: "Cancel",
    },
  },
  recruitment: {
    loading: "Loading…",
    saving: "Saving…",
    save: "Save",
    cancel: "Cancel",
    refresh: "Refresh",
    back: "Back to applications",
    today: "Today",
    filter: { all: "All" },
    job_status: { draft: "Draft", published: "Published", closed: "Closed", archived: "Archived" },
    app_status: {
      new: "New",
      screening: "Screening",
      shortlisted: "Shortlisted",
      interview: "Interview",
      final_review: "Final review",
      accepted: "Accepted",
      rejected: "Rejected",
    },
    employment: { full_time: "Full time", part_time: "Part time", contract: "Contract", internship: "Internship" },
    jobs: {
      add: "New job",
      edit: "Edit job",
      search: "Search jobs…",
      empty: "No jobs yet",
      publish: "Publish",
      hide: "Hide",
      close: "Close",
      archive: "Archive",
      confirm_delete: "Delete this job?",
      col: { title: "Title", department: "Department", location: "Location", status: "Status", apps: "Apps" },
      fields: {
        title: "Job title",
        slug: "Slug",
        department: "Department",
        employment_type: "Employment type",
        location: "Location",
        status: "Status",
        description: "About the role",
        responsibilities: "What you will do",
        requirements: "What we look for",
        nice_to_have: "Nice to have",
        benefits: "What we offer",
        skills: "Skills",
        list_hint: "One item per line",
      },
    },
    applications: {
      search: "Search candidates…",
      empty: "No applications",
      general: "General application",
      years: "{{count}} years",
      col: {
        candidate: "Candidate",
        job: "Role",
        experience: "Experience",
        date: "Date",
        status: "Status",
        email: "Email",
        phone: "Phone",
        city: "City",
      },
    },
    summary: { total: "Total" },
    pipeline: { title: "Pipeline" },
    notes: { title: "Team notes", placeholder: "Internal note…", add: "Add note" },
    timeline: { title: "Timeline" },
    cv: { view: "View CV", download: "Download" },
    settings: {
      notify_email: "Team notification email",
      accepting: "Accepting applications",
      honeypot: "Enable anti-spam honeypot",
      cv_max: "Max CV size (KB)",
      saved: "Settings saved",
    },
  },
  credentials: {
    popup: {
      title: "Admin Credentials",
      subtitle: "Save these credentials now — they were also emailed to the customer",
      email: "Email Address",
      password: "Password",
      copy: "Copy to clipboard",
      copy_all: "Copy all",
      close: "Close",
      warning:
        "This password is shown only once. Please save it securely as it cannot be retrieved later.",
      tenant: "Tenant Name",
      workspace: "Workspace ID",
      login_url: "Login link",
      next_steps: "Quick links after activation",
      open_atelier: "Atelier",
      open_subscription: "Subscription",
      open_payments: "Payments",
    },
  },
};

export default en;
